'use strict';
const utils = require('./utils/utils');
utils.reportBI('506');
const tStart = new Date().getTime();
const W = window.W || {};
W.Site = W.Site || {};
W.Site.Common = W.Site.Common || {};
export const cookieNotificator = W.Site.Common.cookieNotificator || (() => {
  const version = '!!XYZ!!';
  const baseUrl = version.indexOf('static.parastorage.com') !== -1 ? version : 'http://localhost:3200/';
  const userDetails = require('modules/userDetails');
  const EUValitaor = require('modules/EUValitaor');
  const visual = require('modules/visual');
  const locale = require('modules/locale');
  let inited = false;
  const lang = userDetails.language();

  function init() {
    if (inited) {
      return;
    }
    inited = true;

    if (!userDetails.sawNotification() && userDetails.isAnonymous()) {
      EUValitaor.validate().then(result => {
        if (typeof result.data.show !== 'undefined' && result.data.show) {
          utils.reportBI('508', ['required=1']);
          utils.reportBI('510');
          const ts = new Date().getTime();
          const data = {lang, locale: locale.get(lang)};
          visual.create(data, baseUrl, ts);

        } else {
          utils.reportBI('508', ['required=0']);
        }
      })
      .catch(error => console.log(error));
    } else {
      utils.reportBI('509', ['confirmation=true']);
    }
  }

  return init;

})();

W.Site.Common.cookieNotificator = cookieNotificator;

if (document.readyState === 'complete') {
  W.Site.Common.cookieNotificator();
  utils.reportBI('507', [`delta=${new Date().getTime() - tStart}`]);
} else {
  utils.reportBI('507', [`delta=${new Date().getTime() - tStart}`]);
  window.onload = W.Site.Common.cookieNotificator;
}



// WEBPACK FOOTER //
// ./client.js